export enum ModeOpenDemand {
  CREATE,
  GESTION,
  CONSULTATION
}
